// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --footer-background-colour: #333333;
  --footer-link-colour: #fff;
  --nav-bar-background-colour: #fff;
  --product-content-padding: 0 10px;
}

.menu-card-content-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.menu-card-content-description {
  font-size: 14px;
  margin-bottom: 0;
}
.menu-card-content-title {
  font-family: Tenant-Bold, Courier, Helvetica, sans-serif;
  font-size: 17px;
  margin: 3px 0;
}
.menu-card-image {
  min-height: 185px;
  min-width: 328px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
}
.menu-card-image img {
  max-width: 100%;
}

.menu-card-price {
  display: flex;
  font-family: Tenant-Bold, Courier, Helvetica, sans-serif;
  justify-content: space-between;
  padding: 5px 0;
}

.menu-card-price-amount .mat-icon {
  height: 20px;
  width: 20px;
  font-size: 20px;
}

.menu-card-price-amount:not(:disabled) {
  color: #fff;
}

.menu-card-add-button:not(:disabled) {
  background-color: #E3000E;
}

.menu-card-add-button {
  width: 100%;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  overflow: hidden;
}

.menu-card-add-button.notify {
  background-color: #0D6EFD;
}

.menu-card-content {
  margin-bottom: 3px;
}

.flex-row.menu-card-add-button-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flex-row.menu-card-add-button-inner span {
  margin: 0 2px;
}

.no-pointer-events {
  pointer-events: none;
}

.category {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.category-item {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 0 25px 1px rgba(53, 53, 53, 0.25);
  margin: 0 15px 35px;
  max-width: 350px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.menu-card-imageless {
  width: 328px;
}

.category-item-unavaliable {
  opacity: 0.75;
}

.menu-card-content-nutrition {
  font-size: 12px;
}

@media screen and (max-width: 1023px) {
  .menu-card-image {
    min-height: 185px;
    min-width: 328px;
  }
}
@media screen and (max-width: 479px) {
  .menu-card-image {
    min-height: 95px;
    min-width: 170px;
  }
  .menu-card.category-item {
    margin: 0 10px 20px;
  }
  h3.menu-card-content-title {
    margin: 0;
    font-size: 14px !important;
  }
  p.menu-card-content-description {
    font-size: 10px;
    padding: 0 3px;
  }
  .menu-card.category-item {
    margin: 0 2px 5px;
    padding: 1px;
    overflow: hidden;
    width: 100%;
  }
  .menu-card-price {
    padding: 1px 0;
  }
  .menu-card-price-amount {
    font-size: 11px;
  }
  .menu-card-price-amount .mat-icon {
    height: 15px;
    width: 15px;
    margin-top: 0;
    font-size: 15px;
  }
  .menu-card-add-button {
    height: 30px;
  }
  .menu-card-imageless {
    width: unset;
  }
  .menu-card-imageless .menu-card-price {
    padding: 5px 0;
  }
}
@media screen and (max-width: 479px) and (max-width: 340px) {
  .menu-card.category-item {
    width: 300px;
  }
  .menu-card-image {
    min-width: unset;
    min-height: 156px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
